import type { IconData } from '@stacksjs/iconify-core'

export const dashboardGauge2Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M46.5 27C46.5 14.574 36.426 4.5 24 4.5S1.5 14.574 1.5 27c0 3.264.684 7.178 2.138 10.053C4.51 38.78 6.312 39.5 7.923 39.5h6.275c.716 0 1.205-.735 1.04-1.432A9 9 0 0 1 15 36c0-.867.123-1.705.351-2.498c.206-.714-.287-1.502-1.03-1.502H9.855A15 15 0 0 1 9 27c0-8.284 6.716-15 15-15s15 6.716 15 15c0 1.753-.3 3.436-.853 5h-4.469c-.742 0-1.235.789-1.03 1.502a9 9 0 0 1 .112 4.566c-.163.697.326 1.432 1.042 1.432h6.276c1.61 0 3.412-.721 4.284-2.447C45.816 34.178 46.5 30.263 46.5 27M29.305 16.199a2.5 2.5 0 0 1 1.768 3.061l-3.39 12.655a5.5 5.5 0 1 1-4.83-1.295l3.39-12.654a2.5 2.5 0 0 1 3.062-1.767\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dashboardGauge2Solid
